import { handleActions } from "redux-actions";
import {
  CATEGORY_DETAILS_LOADED,
  CATEGORY_LOADED,
  SET_CATEGORY_ERROR,
  CLEAR_CATEGORY_DETAILS,
  CLEAR_CATEGORY_ERROR
} from "./constants";
import { mapBreadcrumbs } from "./mapBreadcrumbs";

export { setCategoryError, clearCategoryError } from "./actions";
export {
  getCategoryChildLinks,
  getCategoryDetails,
  getCategoryId,
  getCategoryGender,
  getCategoryTitle,
  getCategoryBreadcrumbs,
  getCategoryError,
  getCategoryHeaderDescription,
  getCategoryIsBrand
} from "./selectors";

const initialState = {};

export default handleActions(
  {
    [CATEGORY_DETAILS_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        details: payload
      };
    },

    [CATEGORY_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        isBrand: payload.isBrand,
        gender: payload.gender,
        type: payload.type,
        childLinks: payload.categories,
        breadcrumbs: mapBreadcrumbs(payload.breadcrumb)
      };
    },

    [CLEAR_CATEGORY_DETAILS]: state => ({
      ...state,
      details: {}
    }),

    [SET_CATEGORY_ERROR]: (state, action) => {
      const { status, message = "" } = action.payload;

      return {
        ...state,
        error: {
          status,
          isTimeout: message.includes("timeout")
        }
      };
    },

    [CLEAR_CATEGORY_ERROR]: state => ({
      ...state,
      error: null
    })
  },
  initialState
);
